/* eslint-disable max-lines */
import { FENCES_CDN_PATH } from '../../fences-constants';
import { FencesSubTypeStructure, FencesTypePropertyStructure } from './fences-subtypes-section-types';

const PROFNASTIL_CHARASTERISTICS_LIST: FencesTypePropertyStructure[] = [
  {
    name: 'Доступная высота:',
    value: '0,5\u201312\u00A0м',
  },
  {
    name: 'Толщина листа:',
    value: '0,35\u20130,8\u00A0мм',
  },
  {
    name: 'Толщина полимерного слоя:',
    value: '0,25\u20130,55 мкм',
  },
  {
    name: 'Высота профиля:',
    value: '8\u201321\u00A0мм',
  },
];

const MODULNYE_OGRAZHDENIYA_CHARASTERISTICS_LIST: FencesTypePropertyStructure[] = [
  {
    name: 'Высота:',
    value: '1,65\u20132,4\u00A0м',
  },
  {
    name: 'Ширина секций:',
    value: '2,5/3\u00A0м',
  },
];

const PANELNYE_OGRAZHDENIYA_CHARASTERISTICS_LIST: FencesTypePropertyStructure[] = [
  {
    name: 'Высота:',
    value: '0,63\u20132,43\u00A0м',
  },
  {
    name: 'Ширина:',
    value: '2,5\u20133\u00A0м',
  },
  {
    name: 'Диаметр проволоки\u00A0от:',
    value: '3,5\u00A0мм',
  },
  {
    name: 'Материал:',
    value: 'Оцинкованная сталь',
  },
];

const PROFNASTIL_SUBTYPES_LIST: FencesSubTypeStructure[] = [
  {
    name: 'Стандартный\u00A08',
    alt: 'Профнастил Стандартный 8',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/zabory-iz-profnastila/1.jpg/1.jpg`,
    properties: [
      {
        name: 'Высота профиля:',
        value: '8\u00A0мм',
      },
      {
        name: 'Высота забора:',
        value: 'до\u00A012\u00A0м',
      },
    ],
  },
  {
    name: 'Стандартный\u00A010',
    alt: 'Профнастил Стандартный 10',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/zabory-iz-profnastila/2.jpg/2.jpg`,
    properties: [
      {
        name: 'Высота профиля:',
        value: '10\u00A0мм',
      },
      {
        name: 'Высота забора:',
        value: 'до\u00A08\u00A0м',
      },
    ],
  },
  {
    name: 'Стандартный\u00A020',
    alt: 'Профнастил Стандартный 20',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/zabory-iz-profnastila/3.jpg/3.jpg`,
    properties: [
      {
        name: 'Высота профиля:',
        value: '20\u00A0мм',
      },
      {
        name: 'Высота забора:',
        value: 'до\u00A012\u00A0м',
      },
    ],
  },
  {
    name: 'Фигурный\u00A08',
    alt: 'Профнастил Фигурный 8',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/zabory-iz-profnastila/4.jpg/4.jpg`,
    properties: [
      {
        name: 'Высота профиля:',
        value: '8\u00A0мм',
      },
      {
        name: 'Высота забора:',
        value: 'до\u00A012\u00A0м',
      },
    ],
  },
  {
    name: 'Фигурный\u00A010',
    alt: 'Профнастил Фигурный 10',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/zabory-iz-profnastila/5.jpg/5.jpg`,
    properties: [
      {
        name: 'Высота профиля:',
        value: '10\u00A0мм',
      },
      {
        name: 'Высота забора:',
        value: 'до\u00A08\u00A0м',
      },
    ],
  },
  {
    name: 'Фигурный\u00A020',
    alt: 'Профнастил Фигурный 20',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/zabory-iz-profnastila/6.jpg/6.jpg`,
    properties: [
      {
        name: 'Высота профиля:',
        value: '20\u00A0мм',
      },
      {
        name: 'Высота забора:',
        value: 'до\u00A012\u00A0м',
      },
    ],
  },
];

const MODULNYE_OGRAZHDENIYA_SUBTYPES_LIST: FencesSubTypeStructure[] = [
  {
    name: '\u00ABВариант\u00A01\u00BB',
    alt: 'Модульное ограждение в варианте 1',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/modulnye-ograzhdeniya/1.jpg/1.jpg`,
    properties: [
      {
        name: 'Высота:',
        value: '2\u00A0м',
      },
    ],
    text:
      'Стальная основа для ограждения, продаётся без заполнения. На\u00A0основу монтируется материал на\u00A0выбор',
  },
  {
    name: '\u00ABВариант\u00A02\u00BB',
    alt: 'Модульное ограждение в варианте 2',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/modulnye-ograzhdeniya/2.jpg/2.jpg`,
    properties: [
      {
        name: 'Высота:',
        value: '1,65 или 2\u00A0м',
      },
      {
        name: 'Толщина стали панели:',
        value: '0,5\u00A0мм',
      },
    ],
    text:
      'Стальная основа для ограждения, продаётся без заполнения. На\u00A0основу монтируется материал на\u00A0выбор',
  },
  {
    name: '\u00ABВариант\u00A03\u00BB',
    alt: 'Модульное ограждение в варианте 3',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/modulnye-ograzhdeniya/3.jpg/3.jpg`,
    properties: [
      {
        name: 'Высота:',
        value: '2\u00A0или 2,4\u00A0м',
      },
      {
        name: 'Толщина стали панели:',
        value: '0,5\u00A0мм',
      },
    ],
    text:
      'Готовое ограждение c\u00A0симметричным рисунком и\u00A0окрашиванием с\u00A0обеих сторон. Сверху дополнено декоративным полотном',
  },
];

const PANELNYE_OGRAZHDENIYA_SUBTYPES_LIST: FencesSubTypeStructure[] = [
  {
    name: 'Bastion',
    alt: 'Панельное ограждение Bastion',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/panelnye-ograzhdeniya/1.jpg/1.jpg`,
    properties: [
      {
        name: 'Диаметр проволоки:',
        value: '5\u00A0и\u00A06\u00A0мм\u00A0/ 6\u00A0и\u00A08\u00A0мм',
      },
      {
        name: 'Ячейка:',
        value: '200 \u00D7 55\u00A0мм',
      },
      {
        name: 'Высота:',
        value: 'до\u00A02,43\u00A0м',
      },
    ],
  },
  {
    name: 'Light',
    alt: 'Панельное ограждение Light',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/panelnye-ograzhdeniya/2.jpg/2.jpg`,
    properties: [
      {
        name: 'Диаметр проволоки:',
        value: '3,5\u00A0мм',
      },
      {
        name: 'Ячейка:',
        value: '200 \u00D7 55\u00A0мм',
      },
      {
        name: 'Высота:',
        value: 'до\u00A02,03\u00A0м',
      },
    ],
  },
  {
    name: 'Medium',
    alt: 'Панельное ограждение Medium',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/panelnye-ograzhdeniya/3.jpg/3.jpg`,
    properties: [
      {
        name: 'Диаметр проволоки:',
        value: '4\u00A0мм',
      },
      {
        name: 'Ячейка:',
        value: '200 \u00D7 55\u00A0мм',
      },
      {
        name: 'Высота:',
        value: 'до\u00A02,43\u00A0м',
      },
    ],
  },
  {
    name: 'Profi',
    alt: 'Панельное ограждение Profi',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/panelnye-ograzhdeniya/4.jpg/4.jpg`,
    properties: [
      {
        name: 'Диаметр проволоки:',
        value: '5\u00A0и\u00A06\u00A0мм',
      },
      {
        name: 'Ячейка:',
        value: '200 \u00D7 55\u00A0мм',
      },
      {
        name: 'Высота:',
        value: 'до\u00A02,43\u00A0м',
      },
    ],
  },
];

const ZHALYUZI_SUBTYPES_LIST: FencesSubTypeStructure[] = [
  {
    name: 'Вершина',
    alt: 'Заборы-жалюзи Вершина',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/zabory-zhalyuzi/1.jpg/1.jpg`,
  },
  {
    name: 'Утёс',
    alt: 'Заборы-жалюзи Утёс',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/zabory-zhalyuzi/2.jpg/2.jpg`,
  },
  {
    name: 'Горизонт',
    alt: 'Заборы-жалюзи Горизонт',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/zabory-zhalyuzi/3.jpg/3.jpg`,
  },
  {
    name: 'Кавказ',
    alt: 'Заборы-жалюзи Кавказ',
    imgSrc: `${FENCES_CDN_PATH}/subtypes/zabory-zhalyuzi/4.jpg/4.jpg`,
  },
];

export const FENCES_SUBTYPES_SECTION_TITLE_MAP: Record<string, string> = {
  'zabory-iz-profnastila': 'Типы заборов из\u00A0профнастила',
  'modulnye-ograzhdeniya': 'Типы модульных ограждений',
  'panelnye-ograzhdeniya': 'Типы панельных ограждений',
  'zabory-zhalyuzi': 'Типы заборов-жалюзи',
};

export const FENCES_TYPES_CHARASTERISTICS_LIST_MAP: Record<string, FencesTypePropertyStructure[]> = {
  'zabory-iz-profnastila': PROFNASTIL_CHARASTERISTICS_LIST,
  'modulnye-ograzhdeniya': MODULNYE_OGRAZHDENIYA_CHARASTERISTICS_LIST,
  'panelnye-ograzhdeniya': PANELNYE_OGRAZHDENIYA_CHARASTERISTICS_LIST,
};

export const FENCES_TYPES_SUBTYPES_LIST_MAP: Record<string, FencesSubTypeStructure[]> = {
  'zabory-iz-profnastila': PROFNASTIL_SUBTYPES_LIST,
  'modulnye-ograzhdeniya': MODULNYE_OGRAZHDENIYA_SUBTYPES_LIST,
  'panelnye-ograzhdeniya': PANELNYE_OGRAZHDENIYA_SUBTYPES_LIST,
  'zabory-zhalyuzi': ZHALYUZI_SUBTYPES_LIST,
};
